module.exports = __webpack_public_path__ + "static/dragon-fire-98fd6df29a149575da40638f1b89b825.svg";